import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

type AppRole = 'admin' | 'vendor' | 'venue_owner' | 'couple' | 'client';

export const useClientAuth = () => {
  const auth = useAuth();
  const [roles, setRoles] = useState<AppRole[]>([]);
  const [rolesLoading, setRolesLoading] = useState(true);

  useEffect(() => {
    const fetchRoles = async () => {
      if (!auth.user) {
        setRoles([]);
        setRolesLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', auth.user.id);

      if (error) {
        console.error('Error fetching roles:', error);
        setRoles([]);
      } else {
        setRoles(data?.map((r) => r.role as AppRole) || []);
      }
      setRolesLoading(false);
    };

    fetchRoles();
  }, [auth.user]);

  const hasRole = (role: AppRole): boolean => roles.includes(role);
  const isClient = hasRole('client');
  const isAdmin = hasRole('admin');
  const isVendor = hasRole('vendor');

  return {
    ...auth,
    roles,
    rolesLoading,
    hasRole,
    isClient,
    isAdmin,
    isVendor,
    isAuthenticated: !!auth.user,
  };
};
